import React from 'react';

import { Text } from '../Text/Text';

import { convertHtmlToReactElement } from './helpers';

export const TextFromHTML = ({ html }: { html: string }) => (
  <Text style={{ wordBreak: 'break-word' }} className="mb-0">
    {convertHtmlToReactElement(html)}
  </Text>
);
